/**
 * Created by Pradeep Kumar on 01/18/2019.
 */

import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {CreepyCarnivalTwoGameMode} from "../gamemode/CreepyCarnivalTwoGameMode";

export class CreepyCarnivalTwoMainRespinZeroBetController extends RespinZeroBetController {

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        return data.nextMode === CreepyCarnivalTwoGameMode.RESPIN || data.nextMode === "STAR_SPIN" || (data.mode === "NORMAL" && data.nextMode === "RESPIN_MAIN");
    }
}